export default function(val: string) {
  return val.toLowerCase()
  .split(' ')
  .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
  .join(' ')
}

